import {
  NavigatorCruiseRecommendationNotificationData,
  UserLikedTripNotificationData,
} from "@cruisen/contract"
import { observer } from "mobx-react-lite"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"
import { NavigatorCruiseCard } from "../NavigatorCruiseCard"
import styles from "./styles.module.scss"

export const CruiseCardsCarousel = observer(
  ({
    data,
    testID,
  }: {
    data: NavigatorCruiseRecommendationNotificationData | UserLikedTripNotificationData
    testID: string
  }) => {
    const responsive = {
      desktop: {
        breakpoint: { max: 3000, min: 0 },
        items: 1,
      },
    }
    const cruises = data?.cruises || []

    const isCarousel = cruises?.length > 1

    return (
      <div>
        {isCarousel ? (
          <>
            <Carousel
              swipeable={false}
              draggable={false}
              responsive={responsive}
              keyBoardControl={false}
              transitionDuration={500}
              sliderClass={styles.cruiseSlider}
            >
              {cruises.map((item, index) => {
                return <NavigatorCruiseCard testID={testID} data={item} key={index} />
              })}
            </Carousel>
          </>
        ) : (
          <NavigatorCruiseCard data={data} testID={testID} />
        )}
      </div>
    )
  },
)
